import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Start page for a user whose role opens no page of the customer navigation (a custom role
 * without any area access). Keeps "go home" redirects from looping.
 */
@Component({
  selector: 'app-no-access',
  imports: [TranslateModule],
  changeDetection: ChangeDetectionStrategy.Default,
  template: `
    <div class="container-fluid mt-4" data-testid="no-access">
      <div class="card">
        <div class="card-body">
          <h4><span class="fa-light fa-fw fa-lock"></span> {{ 'NO_ACCESS_TITLE' | translate }}</h4>
          <p class="mb-0">{{ 'NO_ACCESS_TEXT' | translate }}</p>
        </div>
      </div>
    </div>
  `
})
export class NoAccessComponent { }
